import NoCompanyRoute from "./NoCompanyRoute"
import TenantSettingsRoute from "./TenantSettingsRoute"
import DashboardRoute from "./DashboardRoute"
import SchedulerRoute from "./SchedulerRoute"
import RequestsRoute from "./RequestsRoute"
import OffersRoute from "./OffersRoute"
import InventoryRoute from "./InventoryRoute"
import AssetCreateRoute from "./AssetCreateRoute"
import AssetEditRoute from "./AssetEditRoute"
import ArticleCreateRoute from "./ArticleCreateRoute"
import ArticleEditRoute from "./ArticleEditRoute"
import ReservationCreateRoute from "./ReservationCreateRoute"
import ReservationEditRoute from "./ReservationEditRoute"
import ReservationCopyRoute from "./ReservationCopyRoute"
import CalculationDetailsRoute from "./CalculationDetailsRoute"
import InvoicesRoute from "./InvoicesRoute"
import InvoiceAssignAmountRoute from "./InvoiceAssignAmountRoute"
import ValuationsRoute from "./ValuationsRoute"
import ValuationRoute from "./ValuationRoute"
import UserSettingsRoute from "./UserSettingsRoute"
import HelpRoute from "./HelpRoute"
import OutgoingInvoiceCreateRoute from "./OutgoingInvoiceCreateRoute"
import ManageReferenceValues from "./ManageReferenceValuesRoute"
import LinkLabelsRoute from "./LinkLabelsRoute"
import LinkLabelToAssetRoute from "./LinkLabelToAssetRoute"
import AppSettingsRoute from "./AppSettingsRoute"
import ProductCategoriesRoute from "./ProductCategoriesRoute"
import LiebherrMachineArticlesRoute from "./LiebherrMachineArticlesRoute"
import PrepareShippingRoute from "./PrepareShippingRoute"
import NotificationsRoute from "./NotificationsRoute"
import MonthlyClosing from "./MonthlyClosingRoute"
import StocktakingsRoute from "./StocktakingsRoute"
import StocktakingNotScannedAssetsRoute from "./StocktakingNotScannedAssetsRoute"
import NotFoundRoute from "./NotFoundRoute"
import AssetImportRoute from "./AssetImportRoute"
import InvoiceImportRoute from "./InvoiceImportRoute"
import OutgoingInvoicesRoute from "./OutgoingInvoicesRoute"
import ShippingOrdersRoute from "./ShippingOrdersRoute"
import OfferCreateRoute from "./OfferCreateRoute"
import OfferEditRoute from "./OfferEditRoute"
import RentToBuyChecklistRoute from "./RentToBuyChecklistRoute"
import AdHocOutgoingInvoiceCreateRoute from "./AdHocOutgoingInvoiceCreateRoute"
import RolesAndPermissionsRoute from "./RolesAndPermissionsRoute"
import GlobalAssetOverviewRoute from "./GlobalAssetOverviewRoute"
import MaintenanceRoute from "./MaintenanceRoute"
import CustomerOverviewRoute from "./CustomerOverviewRoute"
import CustomerRoute from "./CustomerRoute"
import FairValueEvaluationRoute from "./FairValueEvaluationRoute"
import CancelInvoicesRoute from "./CancelInvoicesRoute"
import EarlyReturnRoute from "./EarlyReturnRoute"
import OutgoingInvoiceViewRoute from "./OutgoingInvoiceViewRoute"
import OutgoingInvoiceDraftByDateRoute from "./OutgoingInvoiceDraftByDateRoute"

const Routes = {
    dashboard: DashboardRoute,
    requests: RequestsRoute,
    offers: OffersRoute,
    scheduler: SchedulerRoute,
    outgoingInvoices: OutgoingInvoicesRoute,
    inventory: InventoryRoute,
    globalAssetOverview: GlobalAssetOverviewRoute,
    assetImport: AssetImportRoute,
    manageReferenceValues: ManageReferenceValues,
    assetCreate: AssetCreateRoute,
    assetEdit: AssetEditRoute,
    articleCreate: ArticleCreateRoute,
    articleEdit: ArticleEditRoute,
    reservationCreate: ReservationCreateRoute,
    reservationEdit: ReservationEditRoute,
    reservationCopy: ReservationCopyRoute,
    offerCreate: OfferCreateRoute,
    offerEdit: OfferEditRoute,
    prepareShipping: PrepareShippingRoute,
    calculationDetails: CalculationDetailsRoute,
    invoices: InvoicesRoute,
    invoiceAssignAmount: InvoiceAssignAmountRoute,
    invoiceImport: InvoiceImportRoute,
    valuations: ValuationsRoute,
    fairValueEvaluation: FairValueEvaluationRoute,
    outgoingInvoiceCreate: OutgoingInvoiceCreateRoute,
    adHocOutgoingInvoiceCreate: AdHocOutgoingInvoiceCreateRoute,
    valuation: ValuationRoute,
    monthlyClosing: MonthlyClosing,
    linkLabels: LinkLabelsRoute,
    linkLabelToAsset: LinkLabelToAssetRoute,
    userSettings: UserSettingsRoute,
    noCompany: NoCompanyRoute,
    tenantSettings: TenantSettingsRoute,
    appSettings: AppSettingsRoute,
    productCategories: ProductCategoriesRoute,
    liebherrMachineArticlesRoute: LiebherrMachineArticlesRoute,
    notifications: NotificationsRoute,
    help: HelpRoute,
    stocktakings: StocktakingsRoute,
    stocktakingNotScannedAssets: StocktakingNotScannedAssetsRoute,
    maintenance: MaintenanceRoute,
    shippingOrders: ShippingOrdersRoute,
    rentToBuyChecklist: RentToBuyChecklistRoute,
    rolesAndPermissions: RolesAndPermissionsRoute,
    customerOverview: CustomerOverviewRoute,
    customer: CustomerRoute,
    cancelInvoices: CancelInvoicesRoute,
    earlyReturn: EarlyReturnRoute,
    outgoingInvoiceView: OutgoingInvoiceViewRoute,
    outgoingInvoiceDraftByDate: OutgoingInvoiceDraftByDateRoute,
    notFound: NotFoundRoute,
}

export default Routes
